import React from "react";
import {useTranslation} from "react-i18next";
import ImageSlider from "./ImageSlider";

function ProductCard({
                         title,
                         description,
                         images,
                         dimensions,
                         dimensionLabel,
                         advantagesLabel,
                         advantages,
                         additionally,
                         secondDimensionLabel = "",
                         secondDimensions = []
                     }) {
    const {t} = useTranslation();
    return <div>
        <div className="card-body">
            <h6 className="card-title text-uppercase fw-bold text-center">{t(title)}</h6>
        </div>
        <ImageSlider images={images} height={450}/>
        <div className="card-body">

            <p className="card-text">
                {t(description)}
            </p>
            <h5>{t(advantagesLabel)}</h5>
            <ul>
                {advantages.map((advantage, i) => (
                    <li key={i}>{t(advantage)}</li>
                ))}
            </ul>
            <h5 className="card-text">
                {t(dimensionLabel)}
            </h5>
            <ul>
                {dimensions.map((dimension, i) => (
                    <li key={i}>{dimension}</li>
                ))}
            </ul>
            <h5 className="card-text">
                {t(secondDimensionLabel)}
            </h5>
            <ul>
                {secondDimensions.map((dimension, i) => (
                    <li key={i}>{dimension}</li>
                ))}
            </ul>
            <ul>
                {additionally.map((x, i) => (
                    <li key={i}>{t(x)}</li>
                ))}
            </ul>
        </div>
    </div>
}

export default ProductCard;